import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'

export const useArticles = (props, swrOptions) => {
  const genUrl = () => {
    try {
      const propsObject = typeof props === 'function' ? props() : props
      if (propsObject === null) {
        return null
      }
      return `/articles?${stringify(propsObject)}`
    } catch (err) {
      return null
    }
  }
  return useCustomSWR(genUrl, swrOptions)
}
